var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',[_c('span',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.$t('myLoads.myLoadsTable.epd')),expression:"$t('myLoads.myLoadsTable.epd')",modifiers:{"hover":true,"top":true}}],class:_vm.compareDatesEpd(
        _vm.params.value,
        _vm.setLoadStatusColor(_vm.params.data.load_status)
      )},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.params.value))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }